var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../../../../utils/utilNumber";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { actionShowMeQuestTaskFulfillContract } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskFulfillContract = function (props) {
    var className = props.className, tasks = props.tasks, questInfoTasks = props.questInfoTasks, quest = props.quest, onTrySkip = props.onTrySkip, onClickShowMe = props.onClickShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentContractAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentContractAmount >= value.amount;
        var locaReplacements = new Map([
            [ReplacementLoca.amount, utilNumber.format(value.amount)],
        ]);
        var icon = React.createElement(Icon, { icon: IdIcon.ContractsMarketIcn, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentContractAmount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentContractAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { onClick: onClickShowMe, questTask: value })));
    });
    return (React.createElement("div", { key: "fulfillContract", className: className }, list));
};
var mapState = function (state) {
    return {
        baseInfo: state.baseInfo,
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: actionShowMeQuestTaskFulfillContract,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskFulfillContract = connect(mapState, mapDispatch)(_QuestTaskFulfillContract);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskFulfillContract/QuestTaskFulfillContract.tsx
// module id = 2670
// module chunks = 3